export class ObjectUtils {
	/**
	 * Removes all whitespaces from a string
	 * @param text
	 */
	public static removeStringWhitespace(text: string): string {
		return text.replace(/\s/g, '');
	}

	/**
	 * Update badge of nav items
	 * @param rule
	 * @param navItems$
	 */
	public static updateNavItemsBadge(rule: any, navItems$: any): any {
		let newNavItems = [];
		navItems$.forEach(navItems => {
			newNavItems = navItems.map(nav => {
				const navItem = nav;

				const ruleSections = (rule.multipleUiSections && rule.multipleUiSections.length) ?
					rule.multipleUiSections :
					[{
						label: rule.uiSection
					}];

				for (let i = 0; i < ruleSections.length; i++) {
					const UISection = ruleSections[i];

					if (navItem.label.toLocaleLowerCase().indexOf(UISection.label.toLowerCase()) !== -1
						|| navItem.label
							.toLocaleLowerCase()
							.indexOf('revised fields') !== -1
					) {
						const newNavItem = ObjectUtils.recursiveDeepCopy(navItem);

						if (parseInt(newNavItem.badge, 10) > 0) {
							newNavItem.badge = (parseInt(newNavItem.badge, 10) - 1).toString();
						}

						return newNavItem;
					}
				}

				return navItem;
			});
		});

		return newNavItems;
	}

	/**
	 * Verify a valid email
	 * @param email
	 */
	public static validateEmail(email: string): boolean {
		// tslint:disable-next-line:max-line-length
		// eslint-disable-next-line no-useless-escape
		const regularExpresion = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regularExpresion.test(String(email).toLowerCase());
	}

	/**
	 * Verify if the string contains at least one uppercase character
	 * @param string
	 */
	public static hasUppercaseCharacter(string: string): boolean {
		let hasUppercaseCharacter = false;
		for (const c of string) {
			if (c === c.toUpperCase() && c !== c.toLowerCase()) {
				hasUppercaseCharacter = true;
				break;
			}
		}

		return hasUppercaseCharacter;
	}

	/**
	 * Verify if the string contains at least one special character
	 * @param string
	 */
	public static hasSpecialCharacter(string: string): boolean {
		// eslint-disable-next-line no-useless-escape
		const regularExpresion = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

		return regularExpresion.test(string);
	}

	/**
	 * Verify if the string contains at least one number character
	 * @param string
	 */
	public static hasNumberCharacter(string: string): boolean {
		const regularExpresion = /\d/;

		return regularExpresion.test(string);
	}

	/**
	 * Validates if the string given is in correct json format.
	 */
	public static isValidJsonFormat(str: string): boolean {
		try {
			const json = JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	/**
	 * Given an Array, get the first element in the list that match a property
	 * @param items
	 * @param iterableProperty
	 * @param property
	 */
	public static getFirstElementWith(items: any[], iterableProperty: string, property: string): any {
		for (let itemI = 0; itemI < items.length; itemI++) {
			if (items[itemI][property]) {
				return items[itemI];
			}
			if (items[itemI].items && items[itemI].items.length > 0) {
				return ObjectUtils.getFirstElementWith(items[itemI].items, iterableProperty, property);
			}
			return null;
		}
	}

	/**
	 * Given an Array, get all elements that match a property value
	 * @param items
	 * @param iterableProperty
	 * @param property
	 * @param value
	 */
	public static getAllElementsWithValue(items: any[], iterableProperty: string, property: string, value: any): any[] {
		let allMatches = [];
		for (let itemI = 0; itemI < items.length; itemI++) {
			if (items[itemI][property] === value) {
				allMatches.push(items[itemI]);
			}
			if (items[itemI][iterableProperty] && items[itemI][iterableProperty].length > 0) {
				allMatches = allMatches.concat(ObjectUtils.getAllElementsWithValue(items[itemI][iterableProperty], iterableProperty, property, value));
			}
		}

		return allMatches;
	}

	/**
	 * Verify if a string value contains a Pattern expressed in a Regex Array
	 *
	 * @param value
	 * @param patterns
	 */
	public static containsPattern(value: string, patterns: Array<any>): boolean {
		const containsPattern = false;
		if (value) {
			for (let i = 0; i < patterns.length; i++) {
				const pattern = patterns[i];
				const match = value.match(pattern) || [];
				if (match.length > 0) {
					return true;
				}
			}
		}
		return containsPattern;
	}

	/**
	 * Transform a Typescript enum into an array
	 *
	 * @param enumVal
	 * @returns
	 */
	public static enumToArray(enumVal: any): any[] {
		return Object.keys(enumVal).map(key => enumVal[key]);
	}

	/**
	 * Get the actual state from a string
	 *
	 * @param state
	 * @param current
	 */
	public static getStateFromString(state: any, current: string): any {
		let desiredState = state;
		const path = current.split('.');

		for (const newState of path) {
			if (!(newState in desiredState)) {
				console.groupCollapsed('state not found');
				console.log('path', current);
				console.log('current desiredState', desiredState);
				console.log('missing attr', newState);
				console.groupEnd();
				throw new Error('state not found');
			}
			desiredState = desiredState[newState];
		}

		return desiredState;
	}

	/**
	 * Get the Hours since
	 * @param date
	 */
	public static timeInHoursSince(date: Date): number {
		const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
		const interval = seconds / 3600;
		if (interval > 1) {
			return Math.floor(interval);
		}
		return 0;
	}

	/**
	 * Returns a Copy with no references to the original Object
	 * @param obj
	 */
	public static recursiveDeepCopy(obj: any): any {
		let newObj;
		let index;

		if (typeof obj !== 'object') {
			return obj;
		}

		if (!obj) {
			return obj;
		}

		if ('[object Array]' === Object.prototype.toString.apply(obj)) {
			newObj = [];
			for (index = 0; index < obj.length; index += 1) {
				newObj[index] = ObjectUtils.recursiveDeepCopy(obj[index]);
			}
			return newObj;
		}

		newObj = {};
		for (const key in obj) {
			// obj.hasOwnProperty(i)
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				newObj[key] = ObjectUtils.recursiveDeepCopy(obj[key]);
			}
		}
		return newObj;
	}

	/**
	 * Return if an object is empty or not
	 * @param obj
	 */
	public static isEmptyObject(obj: any): boolean {
		return !Object.keys(obj).length;
	}

	/**
	 * Compare a set of arrays to see if they are different
	 * Array can-t contain  any {object} literal
	 * @param items1
	 * @param items2
	 */
	public static arraysEqual(items1: any[], items2: any[]) {
		// Keep single ==
		return JSON.stringify(items1) == JSON.stringify(items2);
	}

	/**
	 * checks a date is greater than today
	 * @param date
	 */
	public static isDateGreaterToday(date): any {
		if (date) {
			const dateToCompare = new Date(date);
			const today = new Date();
			// To match against 12:00
			today.setHours(0,0,0,0);
			return dateToCompare.getTime() > today.getTime();
		}
	}

	/**
	 * Recursive function to flatten any Object given certain attribute name
	 *
	 * @param data Array of objects
	 * @param attribute Name of the Object attribute to find children elements
	 * @param output The Final Array
	 * @returns output
	 */
	public static flattenArrayByAttr(data: any[], attribute: string, output: any[]): any {
		for (const item of data) {
			const {[attribute]: children, ...cleanItem} = item;
			output.push(cleanItem);
			if (children && children.length) {
				const childrenItems = this.flattenArrayByAttr(children, attribute, output);
				Object.assign(output, childrenItems);
			}
		}
		return output;
	}
}
